import { Component } from '@angular/core';

@Component({
  selector: 'app-seo-block',
  standalone: true,
  imports: [],
  templateUrl: './seo-block.component.html',
  styleUrl: './seo-block.component.scss',
})
export class SeoBlockComponent {
  open: boolean = false;
}
